import Component from '@glimmer/component';

export default class MwAboutProduct extends Component {
}
